import React, { memo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PlacesAutocomplete } from '@yme/atoms/autocomplete-places';
import { BottomSheet, Header } from '@yme/atoms/bottom-sheet';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { setIsModalHide } from '@yme/modals/actions';
import { DealerCardCheckoutMap } from '@yme/molecules/dealer-card/checkout';
import { Map } from '@yme/molecules/map';
import { useTranslation } from '@yme/services/i18n';
import { getDealerById } from '@yme/utils/dealer';
import { InputWrapperStyled, MapContainerStyled, MobileContainerStyled } from '../styled';
export const MapModalMobile = memo(({ selectedDealerId, dealers, myLocation, isRightToLeft, googleApiKey, inputLocation, preselectedDealerId, country = '', setInputLocation, handleMapInfoWindowDismiss, submitDealer, setSelectedDealerId, isHiddenCloseIcon, }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isBottomSheetOpened, setIsBottomSheetOpened] = useState(true);
    const handleBottomSheetDismiss = useCallback(() => {
        setIsBottomSheetOpened(false);
    }, []);
    const handleBottomSheetSpringEnd = useCallback(({ type }) => {
        if (type === 'CLOSE') {
            dispatch(setIsModalHide());
        }
    }, [dispatch]);
    const handleDealerSubmit = useCallback(() => {
        submitDealer(selectedDealerId);
        dispatch(setIsModalHide());
    }, [submitDealer, selectedDealerId, dispatch]);
    const infoWindowElement = useCallback((onCancelCallback) => {
        const selectedDealer = getDealerById(dealers, selectedDealerId);
        if (!selectedDealer) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement(DealerCardCheckoutMap, { name: selectedDealer.name, distance: selectedDealer.distance, addressLines: selectedDealer.addressLines, zipCode: selectedDealer.zipCode }),
            React.createElement(ModalWindowFooter, { isCancelButton: true, isSubmitButton: true, submitButtonLabel: t('common_confirm_button'), cancelButtonLabel: t('common_cancel_button'), onSubmit: handleDealerSubmit, onCancel: onCancelCallback, onHide: handleMapInfoWindowDismiss })));
    }, [dealers, handleDealerSubmit, handleMapInfoWindowDismiss, selectedDealerId, t]);
    return (React.createElement(BottomSheet, { open: isBottomSheetOpened, header: React.createElement(Header, { headerLeft: t('common_preferredDealerFindDealerPopUp_header') }), onDismiss: handleBottomSheetDismiss, onSpringEnd: handleBottomSheetSpringEnd },
        React.createElement(MobileContainerStyled, null,
            React.createElement(InputWrapperStyled, null,
                React.createElement(PlacesAutocomplete, { countries: [country], apiKey: googleApiKey, value: inputLocation?.label, title: t('common_preferredDealerFindDealerPopUpYourLocation_label'), isRightToLeft: isRightToLeft, onClear: setInputLocation, onOptionSelect: setInputLocation })),
            React.createElement(MapContainerStyled, null,
                React.createElement(Map, { apiKey: googleApiKey, selectedMarkerId: selectedDealerId, preSelectedMarkerId: preselectedDealerId, markers: dealers, myLocation: myLocation, getMobileInfoWindow: infoWindowElement, mapOptions: {
                        gestureHandling: 'greedy',
                    }, onMarkerSelect: setSelectedDealerId, onMarkerDismiss: handleMapInfoWindowDismiss, isHiddenCloseIcon: isHiddenCloseIcon })))));
});
MapModalMobile.displayName = 'MapMobile_Component';
